import createCompanyAnalysisSettingsService from "./factory";

export default createCompanyAnalysisSettingsService();
